// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.employee.detailed.request.AdminEmployeeLocationAccessRequest */
/* istanbul ignore next */
@GandalfModel
export class AdminEmployeeLocationAccessRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Accessible Locations is required' } })
	@GandalfArray(Number)
	accessibleLocationIds!: number[];

	@GandalfValidator({ notNull: { message: 'Primary Location is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	primaryLocationId!: number;

}
